import styled from 'styled-components';
import {ButtonBaseCss} from './ButtonBase';

export const ImportButton = styled.button`
    ${ButtonBaseCss}
    color: #fff;
    background-color: ${(props) => (props.disabled ? '#9EC0FC' : '#0d6efd')};
    border-color: ${(props) => (props.disabled ? '#9EC0FC' : '#0d6efd')};
`;
